import { ReactNode } from 'react'

import { ButtonLink } from '@/components/Button'
import useBreakpoints from '@/hooks/useBreakpoints'
import { useArcadeRouting } from '@/features/arcade/hooks/routing'

type FooterProps = {
  children?: ReactNode
  className?: string
}

export const Footer = ({ className }: FooterProps) => {
  const { isMobile } = useBreakpoints()
  const { leaderboard, convertPoints } = useArcadeRouting()

  return (
    <footer className={`flex items-center gap-2 justify-center ${className}`}>
      <ButtonLink
        href={leaderboard.path}
        theme="secondary"
        size={isMobile ? 'md' : 'xs'}
        className="w-full"
      >
        Leaderboard
      </ButtonLink>
      <ButtonLink
        href={convertPoints.path}
        theme="green-arcade"
        size={isMobile ? 'md' : 'xs'}
        className="w-full"
      >
        Convert Pts
      </ButtonLink>
    </footer>
  )
}
